<div class="flex gap-3 items-start">
  @for (phaseStatusInfo of phaseStatusInfos(); track phaseStatusInfo.phase) {
    <div class="flex-1 flex flex-col gap-2">
      <app-phase-bar
        tooltipStyleClass="large-tooltip"
        tooltipPosition="top"
        [color]="getPhaseColor(phaseStatusInfo)"
        [label]="getPhaseLabel(phaseStatusInfo)"
        [phaseLocked]="phaseStatusInfo.phaseLocked"
        [pTooltip]="getPhaseTooltip(phaseStatusInfo)"
      />

      @if (phaseStatusInfo.providerStatuses.length) {
        <app-provider-status-table
          [phase]="phaseStatusInfo.phase"
          [providerStatuses]="phaseStatusInfo.providerStatuses"
        />
      }
    </div>
  }
</div>
